import React, { useState } from "react";
import "./cookie.css";

export function CookieConsent() {
  const [close, _setClose] = useState(localStorage.getItem("cookie-consent"));
  if (close) {
    return <></>;
  }
  const setClose = () => {
    localStorage.setItem("cookie-consent", true);
    _setClose(true);
  };
  return (
    <div
      id="cookie-consent-banner"
      className="cookie-consent-default-floating cookie-consent-center cookie-consent-slidein cookie-consent-visible cookie-consent-fix-height"
      role="alertdialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-paragraph"
    >
      <div className="cookie-consent-container">
        <div
          className="cookie-consent-content"
          style={{
            backgroundColor: "white",
            color: "black",
            fontSize: "14px",
          }}
        >
          <div className="cookie-consent-rationale">
            <div
              className="cookie-consent-banner-content cookie-consent-custom-content cookie-consent-banner-content-padded"
              role="document"
              tabIndex={0}
            >
              <div id="cookie-consent-title">Notice</div>
              <div id="cookie-consent-paragraph">
                We and selected partners, use cookies or similar technologies as
                specified in the &nbsp;
                <a href="/cookies" className="cookie-consent-cookie-policy-lnk">
                  cookie policy
                </a>
                .<br />

                To find out more about the categories of personal information
                collected and the purposes for which such information will be
                used, please refer to our&nbsp;
                <a
                  href="/privacy-policy"
                  className="cookie-consent-privacy-policy-link"
                >
                  privacy policy
                </a>
                .<br />
                You can consent to the use of such technologies by closing this
                notice.
              </div>
            </div>
            <div
              className="cookie-consent-opt-group"
              style={{ color: "white !important" }}
            >
              <div className="cookie-consent-opt-group-consent">
                <button
                  className="cookie-consent-accept-btn cookie-consent-btn-primary"
                  style={{
                    backgroundColor: "#0073CE!important",
                    color: "white!important",
                  }}
                  onClick={setClose}
                  tabIndex={0}
                  role="button"
                  aria-pressed="false"
                >
                  Accept
                </button>
              </div>
            </div>
            <button
              type="button"
              className="cookie-consent-close-btn"
              tabIndex={0}
              role="button"
              aria-pressed="false"
              onClick={setClose}
              style={{
                fontSize: "20px!important",
                backgroundColor: "white!important",
              }}
            >
              ×
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
